var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appeals-button"},[_c('router-link',{staticClass:"appeals-button__link",attrs:{"to":{ name: 'appeals-form' }}},[_c('IconComponent',{attrs:{"category":"vuesax-bold","name":"sms"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }